import React, { Component } from "react";
import { Feed, Form, Grid, Message, Segment } from "semantic-ui-react";

import request from "../../utils/request";

class EventContributions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: "",
      data: [],
      eventId: this.props.match.params.id,
      formLoading: false,
      isLoading: true,
      isMounted: false,
      notes: "",
      pages: null,
      password: "",
      xhrResponse: {
        status: "",
        message: ""
      },
      eventHasWinner: false
    };
  }
  fetchData = () => {
    this.setState({
      isLoading: true
    });

    // See if the event has a winner, if yes -> disable new contributions
    request.get(this, `api:/event/${this.state.eventId}`).then(resp => {
      this.setState({
        eventHasWinner: resp.haswinner
      })
    });

    // fetch event contributions
    let payload = {
      pageSize: this.state.pageSize,
      page: this.state.page,
      sorted: this.state.sorted,
      filtered: this.state.filtered,
      ts: Date.now()
    };
    return request.get(this, `api:/event/${this.state.eventId}/contributions`, payload).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      let contributions = [];
      res.data.map(value => {
        return contributions.push({
          key: value.id,
          date: value.dateline,
          icon: "plus square",
          meta: `Accepted by ${value.user.first_name} ${value.user.last_name}`,
          summary: "$" + value.amount + " contribution was added to the event",
          extraText: value.name
        });
      });
      this.setState({
        data: contributions,
        pages: res.pages,
        isLoading: false
      });
    });
  };
  componentDidMount = () => {
    this.fetchData();
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({
        data: [],
        pages: null,
        isLoading: true,
        eventId: this.props.eventId
      });
      this.fetchData();
    }
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleSubmit = e => {
    this.setState({ formLoading: true });
    var self = this;
    var payload = {
      eventId: this.state.eventId,
      amount: this.state.amount,
      notes: this.state.notes,
      password: this.state.password
    };
    return request.post(this, `api:/event/${this.state.eventId}/contributions`, payload).then(resp => {
      if (resp.status === "success") {
        self.setState({
          formLoading: false,
          xhrResponse: resp,
          amount: "",
          notes: "",
          password: ""
        }, () => this.fetchData());
      } 
      if (resp.errors) {
        self.setState({
          formLoading: false,
          xhrResponse: {
            status: "error",
            message: resp.errors.password[0] ? resp.errors.password[0] : "Your contribution could not be saved at the time"
          }
        });
      }
    });
  };
  render() {
    const {
      amount,
      notes,
      password,
      data,
      isLoading,
      formLoading,
      xhrResponse,
      eventHasWinner
    } = this.state;
    return (
      <Segment basic loading={isLoading}>
        <Grid stackable>
          <Grid.Column width={6}>
            <Form
              loading={formLoading}
              success={xhrResponse.status === "success"}
              error={xhrResponse.status === "error" || xhrResponse.exception}
              warning={eventHasWinner}
              onSubmit={this.handleSubmit}
            >
              <Message success content={xhrResponse.message} />
              <Message warning content={eventHasWinner ? "Contributions cannot be made to completed events" : ""} />
              <Message error content={xhrResponse.message} />
              <Form.Input
                type="number"
                name="amount"
                label="Amount"
                placeholder="Amount"
                value={amount}
                fluid
                onChange={this.handleChange}
              />
              <Form.TextArea
                name="notes"
                label="Notes"
                placeholder="Notes..."
                value={notes}
                onChange={this.handleChange}
              />
              <Form.Input
                type="password"
                name="password"
                label="Confirm Password"
                placeholder="Confirm Password"
                value={password}
                fluid
                onChange={this.handleChange}
              />
              <Form.Button
                primary
                icon="checkmark"
                content="OK"
                loading={formLoading}
                fluid
                disabled={eventHasWinner || password == ""}
              />
            </Form>
          </Grid.Column>
          <Grid.Column width={10}>
            <Feed events={data} />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default EventContributions;
